import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/services/data.service';
import {
  SurveyService,
  SurveySubmitPayload,
} from 'src/app/services/survey.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-survey-form-pickup',
  templateUrl: './survey-form-pickup.component.html',
  styleUrls: ['./survey-form-pickup.component.scss'],
})
export class SurveyFormPickupComponent implements OnInit {
  refno: any;

  options: any;
  form: FormGroup;
  isSubmitted = false;
  result: any;
  telephone: string = environment.contact.telephone_us;
  feedbackExists: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private surveyService: SurveyService,
    private spinner: NgxSpinnerService,
    private dataService: DataService,
    private toastr: ToastrService,
  ) {
    this.form = this.fb.group({
      rating: [null, Validators.required],
      selectedOptions: this.fb.array([], [this.atLeastOneCheckbox]),
      additionalComments: [null, Validators.maxLength(500)],
      type: ['pickup'],
    });
  }
  atLeastOneCheckbox(control: AbstractControl) {
    const formArray = control as FormArray;
    return formArray && formArray.length > 0 ? null : { required: true };
  }

  ngOnInit(): void {
    this.refno = this.route.snapshot.params.refno; //atob(this.route.snapshot.params.refno);

    this.surveyService.getPickupOptions().subscribe((options) => {
      this.options = options;
    });

    this.surveyService.getSurveyRecord(this.refno, 'pickup').subscribe((result) => {
      console.log('getSurveyRecord', result);
      this.feedbackExists = true;
    });

    this.loadInvoiceStatuses();
  }

  get selectedOptions(): FormArray {
    return this.form.get('selectedOptions') as FormArray;
  }

  toggleOption(optionId: number, event: any) {
    console.log(optionId, event.target.checked);

    if (event.target.checked) {
      this.selectedOptions.push(this.fb.control(optionId));
    } else {
      const index = this.selectedOptions.controls.findIndex(
        (x) => x.value === optionId,
      );
      this.selectedOptions.removeAt(index);
    }
  }

  selectRating(value: number) {
    this.form.patchValue({ rating: value });
  }

  submit() {
    this.isSubmitted = true;
    const selectedIds = this.form.value.selectedOptions
      .map((checked: boolean, i: number) =>
        checked ? this.options[i].id : null,
      )
      .filter((v: number | null) => v !== null);

    const payload: SurveySubmitPayload = {
      referenceNo: this.refno,
      rating: this.form.value.rating,
      selectedOptionIds: selectedIds,
      additionalComments: this.form.value.additionalComments,
      type: this.form.value.type,
    };

    console.log(payload);
    this.surveyService.submitSurvey(payload).subscribe(() => {
      console.log('Submitted successfully');
      this.toastr.success('Survey feedback has been submitted!');
      this.router.navigateByUrl('/home', { replaceUrl: true });
    });
  }

  get formControl() {
    return this.form.controls;
  }

  loadInvoiceStatuses(): void {
    this.spinner.show();
    let invoice: string = this.refno;
    invoice = invoice.trim();
    this.dataService.getInvoiceStatuses(invoice).subscribe(
      (res) => {
        this.result = res;
        console.log('result result:', this.result);
        console.log('result res:', this.result);
        this.spinner.hide();
      } /* ,
        (error) => {
          console.log(error);
          this.spinner.hide();
          this.result
        } */,
    );
    console.log('result:', this.result);
  }
}
